export const APP_VERSION = process.env.REACT_APP_VERSION;
export const BUILD_DATE =
  process.env.REACT_APP_BUILD_DATE === "development"
    ? new Date().toISOString()
    : process.env.REACT_APP_BUILD_DATE || new Date().toISOString();

